module.exports = __webpack_public_path__ + "static/smNewCover-2be9fb830509588b4c806f0192343866.png";